/** Landing-page slogans. `highlight` lists the exact words shown in the accent colour. */
interface Slogan { text: string; highlight: string[] }

export const SLOGANS: Slogan[] = [
  { text: 'Find the moment. Start the story.', highlight: ['moment', 'story'] },
  { text: 'Your next story starts here.', highlight: ['story'] },
  { text: 'Every frame has a future.', highlight: ['frame', 'future'] },
  { text: 'Great stories start with a search.', highlight: ['stories', 'search'] },
  { text: 'Somewhere in here is your next great shot.', highlight: ['great shot'] },
  { text: 'Give yesterday’s footage a new tomorrow.', highlight: ['tomorrow'] },
  { text: 'Find the words. Capture the moment.', highlight: ['words', 'moment'] },
  { text: 'A new angle on everything you’ve captured.', highlight: ['angle'] },
  { text: 'Discover what deserves another look.', highlight: ['another look'] },
  { text: 'Your archive has more to say.', highlight: ['archive'] },
  { text: 'Bring the right moment into focus.', highlight: ['moment', 'focus'] },
  { text: 'The next cut starts here.', highlight: ['cut'] },
  { text: 'Old footage. New possibilities.', highlight: ['New possibilities'] },
  { text: 'Follow an idea. Find the footage.', highlight: ['idea', 'footage'] },
  { text: 'Make something new from what you already have.', highlight: ['new'] },
  { text: 'There’s a story in here with your name on it.', highlight: ['story', 'name'] },
  { text: 'Find the shot that says it all.', highlight: ['shot'] },
  { text: 'Rediscover the moments that matter.', highlight: ['Rediscover'] },
  { text: 'What story will you tell next?', highlight: ['story'] },
  { text: 'See your media in a new light.', highlight: ['new light'] },
];

interface SloganPart { text: string; hot: boolean }

/** Split a slogan into plain and highlighted parts (first whole-word occurrence of each highlight). */
export function sloganParts(s: Slogan): SloganPart[] {
  const spans: Array<[number, number]> = [];
  for (const word of s.highlight) {
    const m = new RegExp(`(?<![\\p{L}\\p{N}])${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?![\\p{L}\\p{N}])`, 'u').exec(s.text);
    if (m) spans.push([m.index, m.index + word.length]);
  }
  spans.sort((a, b) => a[0] - b[0]);
  const parts: SloganPart[] = [];
  let at = 0;
  for (const [from, to] of spans) {
    if (from < at) continue;
    if (from > at) parts.push({ text: s.text.slice(at, from), hot: false });
    parts.push({ text: s.text.slice(from, to), hot: true });
    at = to;
  }
  if (at < s.text.length) parts.push({ text: s.text.slice(at), hot: false });
  return parts;
}

export const randomSlogan = (rand: () => number = Math.random): Slogan => SLOGANS[Math.min(SLOGANS.length - 1, Math.floor(rand() * SLOGANS.length))]!;
